/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react';
import { MaterialReactTable, MRT_ColumnDef} from 'material-react-table';
import { SourceDatasetsRow } from './constants';
import Link from '@mui/material/Link';
import { getUrlForDataset } from './DrivingScenarioProperties';

import {ArgosTableSimple} from "../../../../../../components/Table/ArgosTableSimple";
import ArgosFlexbox from '../../../../../../components/Containers/ArgosFlexbox';

interface ISourceDatasetsProps {
  studyId: string,
  sourceDatasets: SourceDatasetsRow[]
}


const SourceDatasets = (props: ISourceDatasetsProps) => {
  const tableData = props?.sourceDatasets
  const sourceDatasetInfoColumns: MRT_ColumnDef<SourceDatasetsRow>[] =  [
      {
        accessorKey: 'name',
        id: 'name',
        header: 'Name',
        size: 500, 
        Cell: ({cell, row, renderedCellValue}) => {
          const id = row.original.id
          const name = row.original.name
          const link_to_source: string = getUrlForDataset(0, props.studyId, id)
          return (
            <Link href={link_to_source} underline="hover" target="_blank" rel="noreferrer">
              {renderedCellValue}
            </Link>
          )
          
        },
      }
    ]
  
  return (
    <ArgosFlexbox style={{overflow: "auto"}} vertical>
      <ArgosTableSimple
        columns={sourceDatasetInfoColumns}
        data={tableData}
        enableExpanding={false}
        enableTopToolbar={false}
        enablePagination={false}
      />
    </ArgosFlexbox>
  )
}

export default SourceDatasets;